import { BgisLegendInfoDetails } from "../../bgis/components/maparea/sidebar/menus/legend";

// test
export const LegendInfos: React.FC<{}> = () => {

    return (
        <BgisLegendInfoDetails>
              <h3 className="bgis-headline6">Weitere Infos zur BEAT-Karte</h3>
              <span className="bgis-caption">
                <a href="https://www.umweltbundesamt.at/umweltthemen/uvpsup/beat-karte">Anwendung der BEAT Karte.</a>
                </span><br/><br/>
            <h3 className="bgis-headline6">Erklärung zu DSGV und Datenschutz</h3>
            <span className="bgis-caption">
                Es werden ausschließlich öffentlich zugängliche Daten (<a href="https://kataster.bev.gv.at" target="blank">https://kataster.bev.gv.at</a>)
                sowie Inspire konform veröffentlichte Erhebungen (<a href="https://geometadatensuche.inspire.gv.at/metadatensuche/srv/api/records/2022c513-fc01-40b6-8841-0d176dd88ea4">
                Wertvolle landwirtschaftliche Produktionsflächen in Österreich</a>) bzw. 
                (<a href="https://inspire.lfrz.gv.at/000101/ds/WertvolleLandwirtschaftlicheProduktionsflaechen_EPSG31287.zip">
                Wertvolle landwirtschaftliche Produktionsflächen in Österreich: Shapefile</a>) benutzt. Auf Grund der 
                Öffentlichkeit dieser Daten besteht keine DSGV Relevanz.</span><br/><br/>
            <h3 className="bgis-headline6">Verwendete Datengrundlagen</h3><br/> 
            <h4 className="bgis-title">Beat Daten</h4>
            <span className="bgis-caption">
                Bei den gegenständlichen Daten handelt es sich um die aus dem Forschungsprojekt BEAT - "Bodenbedarf für die Ernährungssicherung
                in Österreich" ermittelten wertvollen landwirtschaftlichen Produktionsflächen innerhalb der Kleinproduktionsgebiete für die
                aktuelle klimatische Situation. Die wertvollen landwirtschaftlichen Flächenpolygone sind nach deren Nutzung (Acker oder
                Grünland) sowie dem Kleinproduktionsgebiet zusammengeführt.<br />
                &copy; <a href="https://creativecommons.org/licenses/by/4.0/legalcode.de">Creative Commons CC BY 4.0</a><br />
                Bundesministerium für Land- und Forstwirtschaft, Regionen und Wasserwirtschaft
            </span><br/><br/>
            <h4 className="bgis-title">Administrative Grenzen</h4>
            <span className="bgis-caption">
                &copy; <a href="https://creativecommons.org/licenses/by/4.0/legalcode.de">Creative Commons CC BY 4.0</a><br />
                Bundesamt für Eich- und Vermessungswesen (BEV)<br />
                Schiffamtsgasse 1-3<br/>
                1020 Wien<br />
            </span><br/>
            <h4>Kataster</h4>
            <span className="bgis-caption">
                &copy; <a href="https://creativecommons.org/licenses/by/4.0/legalcode.de">Creative Commons CC BY 4.0</a><br />
                Bundesamt für Eich- und Vermessungswesen (BEV)<br />
                Schiffamtsgasse 1-3<br />
                1020 Wien<br /></span><br/>

            <h4 className="bgis-title">Grundkarte</h4>
            <span className="bgis-caption">
                &copy; <a href="">Open Government Data license of Austria</a><br />
                <a href="https://basemap.at/" target="_blank">basemap.at</a>
            </span>
        </BgisLegendInfoDetails>
    );
}